import { z } from 'zod';
import {
  AcademicYear,
  CourseId,
  OrgId,
  ResourceId,
  TermId,
  UnixTimestamp,
  UserId,
  createBrandedString,
  createBrandedUuid,
  createBrandedUuidLoose,
  dateToUnix,
  nowUnix,
  unixToDate,
} from '@triedge/domain-core/types';

export {
  AcademicYear,
  CourseId,
  OrgId,
  ResourceId,
  TermId,
  UnixTimestamp,
  UserId,
  createBrandedString,
  createBrandedUuid,
  createBrandedUuidLoose,
  dateToUnix,
  nowUnix,
  unixToDate,
};

export const FacultyId = createBrandedUuid('FacultyId');
export type FacultyId = z.infer<typeof FacultyId>;

export const FacultyDivisionAssignmentId = createBrandedUuid('FacultyDivisionAssignmentId');
export type FacultyDivisionAssignmentId = z.infer<typeof FacultyDivisionAssignmentId>;

export const FacultyTeachingAssignmentId = createBrandedUuid('FacultyTeachingAssignmentId');
export type FacultyTeachingAssignmentId = z.infer<typeof FacultyTeachingAssignmentId>;

export const FacultyScheduleId = createBrandedUuid('FacultyScheduleId');
export type FacultyScheduleId = z.infer<typeof FacultyScheduleId>;

export const FacultyEmergencyContactId = createBrandedUuid('FacultyEmergencyContactId');
export type FacultyEmergencyContactId = z.infer<typeof FacultyEmergencyContactId>;

export const FacultyNoteId = createBrandedUuid('FacultyNoteId');
export type FacultyNoteId = z.infer<typeof FacultyNoteId>;

export const FacultyTagId = createBrandedUuid('FacultyTagId');
export type FacultyTagId = z.infer<typeof FacultyTagId>;

export const FacultyCommunicationId = createBrandedUuid('FacultyCommunicationId');
export type FacultyCommunicationId = z.infer<typeof FacultyCommunicationId>;

export const DivisionId = createBrandedString('DivisionId');
export type DivisionId = z.infer<typeof DivisionId>;

export const SectionId = createBrandedString('SectionId');
export type SectionId = z.infer<typeof SectionId>;
